


















import { Component, Prop, Vue } from 'vue-property-decorator';

import { UbidotsEndpoint } from '@/types/core-push';

@Component
export default class UbidotsEndpointView extends Vue {
  
  @Prop({ default: {},  type: Object}) ubidotsEndpoint!: UbidotsEndpoint;

  
}
